'use client';

import React from 'react';
import styles from './security.module.css';

/**
 * Environment Classification Banner
 *
 * Non-dismissible banner indicating operating environment and data classification.
 * SOC 2 CC7.1 / CC8.1. Single border, monospace label chrome.
 *
 * Configure via:
 *   NEXT_PUBLIC_ENVIRONMENT_LABEL = "PRODUCTION" | "STAGING" | "DEVELOPMENT" | "UAT"
 *   NEXT_PUBLIC_DATA_CLASSIFICATION = "CONFIDENTIAL" | "INTERNAL" | "PUBLIC"
 */

const BANNER_COLORS: Record<string, { bg: string; text: string; border: string }> = {
  PRODUCTION: { bg: '#052e16', text: '#86efac', border: '#166534' },
  STAGING: { bg: '#422006', text: '#fde047', border: '#854d0e' },
  UAT: { bg: '#1e1b4b', text: '#a5b4fc', border: '#3730a3' },
  DEVELOPMENT: { bg: '#450a0a', text: '#fca5a5', border: '#991b1b' },
};

export function SecurityBanner() {
  const envLabel = (process.env.NEXT_PUBLIC_ENVIRONMENT_LABEL || '').toUpperCase();
  const dataClassification = process.env.NEXT_PUBLIC_DATA_CLASSIFICATION || '';

  if (!envLabel) return null;

  const colors =
    BANNER_COLORS[envLabel] ??
    BANNER_COLORS.DEVELOPMENT ?? { bg: '#dc2626', text: '#ffffff', border: '#b91c1c' };

  return (
    <div
      role="status"
      aria-label={`Environment: ${envLabel}${dataClassification ? `, classification: ${dataClassification}` : ''}`}
      className={styles.banner}
      style={{
        backgroundColor: colors.bg,
        color: colors.text,
        borderBottomColor: colors.border,
      }}
    >
      <span>{envLabel} ENVIRONMENT</span>
      {dataClassification ? (
        <>
          <span style={{ opacity: 0.4 }} aria-hidden>
            |
          </span>
          <span>{dataClassification}</span>
        </>
      ) : null}
    </div>
  );
}

export default SecurityBanner;
